module.exports = __webpack_public_path__ + "ui-lib-logo.5a21ac07.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/components/routes/Home/images/ui-lib-logo.svg
// module id = ETpA
// module chunks = 0